<template>
  <div>
    <div class="level">
      <div class="level-left level-is-shrinkable">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li class="is-hidden-touch">
              <router-link :to="{ path: '/items?' + breadcrumb(0) }">{{
                $t(`items.categories.${item.category}`)
              }}</router-link>
            </li>
            <li class="is-hidden-touch" v-if="item.subCategory">
              <router-link :to="{ path: '/items?' + breadcrumb(1) }">{{
                $t(`items.subCategories.${item.subCategory}`)
              }}</router-link>
            </li>
            <li v-if="item.brand">
              <router-link :to="{ path: '/items?' + breadcrumb(2) }">{{
                item.brand
              }}</router-link>
            </li>
            <li v-if="item.model">
              <router-link :to="{ path: '/items?' + breadcrumb(3) }">{{
                item.model
              }}</router-link>
            </li>
            <li class="is-active">
              <a href="#" aria-current="page">{{ item.title }}</a>
            </li>
          </ul>
        </nav>
      </div>

      <div class="level-right">
        <b-field>
          <b-input
            v-model="searchQuery"
            :placeholder="$t('app.newSearch')"
            type="search"
            ref="search"
            icon-pack="fas"
            icon="search"
            icon-right="close-circle"
            icon-right-clickable
            @icon-right-click="clearSearch"
            @keyup.enter.native="triggerSearch"
          >
          </b-input>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import helpers from "../../helpers";

export default {
  props: ["item"],
  mixins: [helpers],
  data() {
    return {
      searchQuery: ""
    };
  },

  methods: {
    clearSearch() {
      if (this.$refs.search.newValue) {
        this.$refs.search.newValue = "";
        console.log("cleared");
      }
    },
    triggerSearch() {
      if (this.validIdLookup(this.searchQuery)) {
        this.$router.replace({
          name: "Item",
          params: { item: this.searchQuery }
        });
      } else {
        this.$router.push({
          name: "Items",
          query: { q: this.searchQuery }
        });
      }
    },
    breadcrumb: function(part) {
      let params = [
        {
          name: "category",
          value: this.item.category
        },
        {
          name: "subCategory",
          value: this.item.subCategory
        },
        {
          name: "brand",
          value: this.item.brand
        },
        {
          name: "model",
          value: this.item.model
        }
      ];

      let base = "";

      params.forEach(param => {
        if (base === "") {
          base += param.name + ":" + param.value;
        } else {
          base += "::" + param.name + ":" + param.value;
        }
      });

      var test = base.split("::");
      var res = "";
      var i = 0;

      for (i = 0; i <= part; i++) {
        res += test[i] + (i < part ? "::" : "");
      }

      return "?filter_by=" + encodeURIComponent(res);
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: $desktop) {
  .breadcrumb li + li::before {
    content: "";
  }
  .breadcrumb li:not(.is-hidden-touch, .is-active)::after {
    color: #b5b5b5;
    content: "\0002f";
  }
}
</style>
